import { FieldType, Model, Schema } from "@core/index";
import { ITerminal } from "./CMS";
import { IContactNumber } from "./ContactNumber";

export interface IContactAddress {
    guid?: string;
    title?: string;
    country?: string;
    city?: string;
    address?: string;
    postalCode?: string;
    telephone?: IContactNumber;
    lat?: number;
    lng?: number;
}

export class ContactAddress extends Model implements IContactAddress {
    public static schema: Schema = new Schema("Address");
    public guid?: string;
    public title?: string;
    public country?: string;
    public city?: string;
    public address?: string;
    public postalCode?: string;
    public telephone?: IContactNumber;
    public lat?: number;
    public lng?: number;

    constructor(values: IContactAddress) {
        super(ContactAddress.schema);
        this.setValues(values);
    }
}

ContactAddress.schema.addField("guid").type(FieldType.String);
ContactAddress.schema.addField("title").type(FieldType.String).required();
ContactAddress.schema.addField("city").type(FieldType.String).required().pattern(/^[a-zA-Z ]*$/);
ContactAddress.schema.addField("country").type(FieldType.String).required();
ContactAddress.schema.addField("address").type(FieldType.String).required();
ContactAddress.schema.addField("postalCode").type(FieldType.String);
ContactAddress.schema.addField("telephone").type(FieldType.Object);
ContactAddress.schema.addField("lat").type(FieldType.Number);
ContactAddress.schema.addField("lng").type(FieldType.Number);
ContactAddress.schema.freeze();

export const mapTerminalToContactAddress = (t: ITerminal): IContactAddress => {
    const contactAddress: IContactAddress = {
        address: t.address,
        title: t.displayText,
        lat: t.location?.latitude,
        lng: t.location?.longitude
    }
    return contactAddress;
}

